import React, { FC } from 'react';

export const SubHeaderRails: FC<{}> = ({ children }) => (
  <div className="sub-header__rails">{children}</div>
);
